/** SSR-safe stub matching the Storage contract for zustand `persist` during `window === undefined`. */
export const noopStorage: Storage = {
  length: 0,
  clear: () => {},
  getItem: () => null,
  key: () => null,
  removeItem: () => {},
  setItem: () => {},
};
